import React, { useEffect } from "react";
import "./transparentHeader.scss";
import Navbar from "./Navbar/Navbar";
import { StaticImage } from "gatsby-plugin-image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons/faAngleRight";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons/faAngleDown";

import MVLogo from "../../../resources/images/logo-wordmark-black.png";
import WhatsNewIcon from "../../../resources/images/navigation/whats-new.svg";
import IntegrationsIcon from "../../../resources/images/navigation/integrations.svg";
import SecurityIcon from "../../../resources/images/navigation/security.svg";
import ReferralIcon from "../../../resources/images/navigation/referral.svg";

import navData from "./navData";
import globalText from "../../../helpers/globalText";

const TransparentHeaderTemplate = () => {
function handleScroll() {
  const mobileNav = document.querySelector(".main-header-mobile__navigation");
  if (mobileNav) {
    mobileNav.className =
      window.scrollY > 20
        ? "main-header-mobile__navigation scroll"
        : "main-header-mobile__navigation";
  }

  const headerContainer = document.querySelector(".header__container");
  if (headerContainer) {
    if (window.scrollY > 50) {
      headerContainer.style.paddingTop = "30px";
    } else {
      headerContainer.style.paddingTop = "";
    }
  }
}

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <div className="header">
        <div className="header__navigation">
          <div
            className={`header__container ${
              typeof window !== "undefined" && window.location.pathname === "/"
                ? "header__spaces-container"
                : ""
            }`}
            
          >
            <div className="header__link-container">
              <a href="/" className="header__logo-box-container">
                <img
                  src={MVLogo}
                  alt="Motivosity Logo"
                  style={{ width: "175px" }}
                />
              </a>

              <div className="header__box-container">
                <a className="header__link-container-item">
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginLeft: "0",
                    }}
                  >
                    Platform
                    {/* <FontAwesomeIcon
                      icon={faAngleDown}
                      style={{ marginLeft: "7px", marginRight: "0" }}
                      alt="Icon pointing down"
                    /> */}
                  </span>
                  <ProductDropdown data={navData[0]} />
                </a>

                <a className="header__link-container-item" href="/pricing/">
                  Pricing
                </a>

                <a className="header__link-container-item" href="/about-us/">
                  Company
                </a>

                <a className="header__link-container-item" href="/resources/">
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      margin: "0",
                    }}
                  >
                    Resources
                    {/* <FontAwesomeIcon
                      style={{ marginLeft: "7px", marginRight: "0" }}
                      icon={faAngleDown}
                      alt="Icon pointing down"
                    /> */}
                  </span>
                  <ResourcesDropDown data={navData[3]} />
                </a>
              </div>
            </div>

            <div
              className="header__box-container"
              style={{ paddingRight: "5px" }}
            >
              <div className="header__cta-container">
                {/* <a
                  className="header__cta-container-login header__tour-motivosity"
                  href="/tour-motivosity/"
                  target="_blank"
                >
                  Tour Motivosity
                </a> */}

                <a className="header__cta-container-talk-to-sales" href="/demo">
                  Talk to Sales
                </a>

                <a
                  className="header__cta-container-login -ce-ignore"
                  href="https://app.motivosity.com/"
                >
                  Login
                </a>

                <a href="/demo/" className="header__cta-button">
                  {globalText.getADemo}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="main-header-mobile">
        <div className="container main-header-mobile__navigation">
          <div className="main-header-mobile__container">
            <a href="/">
              <div className="main-header-mobile__logo">
                <StaticImage
                  src="../../../resources/images/logo-wordmark-black.png"
                  alt="Motivosity Logo"
                  style={{ width: "100%" }}
                  placeholder="none"
                />
              </div>
            </a>
            <Navbar />
          </div>
        </div>
      </div>
    </>
  );
};

const ProductDropdown = ({ data }) => {
  return (
    <div className="submenu-product">
      <div className="nav-items-container">
        <div className="submenu-product__grid-container">
          {data.links.slice(0, -5).map((link, index) => {
            return (
              <div
                key={index}
                className={
                  index < 3
                    ? "submenu-product__grid-item submenu-product__border-bottom"
                    : "submenu-product__grid-item"
                }
              >
                <ul>
                  <li
                    key={link.label + index}
                    className="submenu-product__icon-container"
                  >
                    <img src={link.image} alt="" />
                    <a
                      href={link.href}
                      className="submenu-product__column-title"
                    >
                      {link.label}
                    </a>
                  </li>
                  {link.inPageLinks.map((item, index) => {
                    return (
                      <li key={item.label + index}>
                        <a
                          href={item.href}
                          className="submenu-product__column-link"
                        >
                          {item.label}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}
        </div>

        <div className="add-ons">
          <div className="add-ons-item-container">
            <div className="submenu-product__footer-item">
              <img
                className="submenu-product__footer-image"
                src={WhatsNewIcon}
                alt=""
              />
              <a className="submenu-product__footer-title" href="/whats-new/">
                What's New
              </a>
            </div>
            <div className="submenu-product__footer-item">
              <img
                className="submenu-product__footer-image"
                src={IntegrationsIcon}
                alt=""
              />
              <a
                className="submenu-product__footer-title"
                href="/integrations/"
              >
                Integrations
              </a>
            </div>

            <div className="submenu-product__footer-item">
              <img
                className="submenu-product__footer-image"
                src={ReferralIcon}
                alt=""
              />
              <a className="submenu-product__footer-title" href="/referral/">
                Referral Program
              </a>
            </div>
            <div className="submenu-product__footer-item">
              <img
                className="submenu-product__footer-image"
                src={SecurityIcon}
                alt=""
              />
              <a
                className="submenu-product__footer-title"
                href="/legal/security/"
              >
                Security
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="submenu-product__footer">
        <div className="submenu-prod-title">Product Add-Ons</div>
        <div className="submenu-item-container">
          <a href="/product/spaces" className="submenu-prod-item">
            <div className="submenu-item-top">
              <svg
                width="25"
                height="25"
                viewBox="0 0 31 31"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_3619_5376)">
                  <path
                    d="M26.6474 6.17233C27.8606 6.17233 28.8929 6.60865 29.7336 7.47065C30.585 8.34329 31 9.35427 31 10.5249V19.6663C31 20.8369 30.5743 21.8586 29.7336 22.7206C28.8823 23.5932 27.8606 24.0189 26.6474 24.0189H20.8901V26.6262C20.8901 27.7968 20.4645 28.8184 19.6238 29.6804C18.7724 30.553 17.7508 30.9787 16.5376 30.9787H4.3632C3.15002 30.9787 2.11775 30.5424 1.27703 29.6804C0.425678 28.8078 0 27.7968 0 26.6262V14.3986C0 13.2279 0.425678 12.2063 1.27703 11.3443C2.12839 10.4717 3.15002 10.046 4.3632 10.046H9.26914V4.35256C9.26914 3.18194 9.69482 2.16032 10.5355 1.29832C11.3869 0.425678 12.4085 0 13.6217 0H19.6131C20.8263 0 21.8586 0.425678 22.6993 1.27703C23.54 2.12839 23.9657 3.13938 23.9657 4.30999V6.18297H26.6262L26.6474 6.17233ZM18.5276 26.6474V24.0402H17.5592C16.346 24.0402 15.3138 23.6038 14.4731 22.7418C13.6217 21.8692 13.2067 20.8582 13.2067 19.6876V12.483H4.3632C3.84174 12.483 3.3735 12.6746 2.9691 13.0577C2.56471 13.4408 2.36251 13.8984 2.36251 14.4198V26.6474C2.36251 27.1689 2.56471 27.6265 2.9691 28.0096C3.3735 28.3927 3.84174 28.5843 4.3632 28.5843H16.5376C17.1016 28.5843 17.5805 28.3927 17.9636 28.0096C18.3467 27.6265 18.5383 27.1689 18.5383 26.6474H18.5276ZM11.6317 4.3632V10.0566H13.2705C13.3876 8.97116 13.8558 8.04531 14.6646 7.30038C15.4734 6.55544 16.4418 6.18297 17.5699 6.18297H21.6244V4.30999C21.6244 3.78853 21.4329 3.34157 21.0498 2.97975C20.6667 2.61792 20.1878 2.43701 19.6238 2.43701H13.6323C13.1109 2.43701 12.6426 2.62856 12.2382 3.01167C11.8338 3.39478 11.6317 3.85239 11.6317 4.37384V4.3632ZM28.6481 19.677V10.5355C28.6481 10.0141 28.4459 9.55647 28.0415 9.17336C27.6371 8.79025 27.1689 8.5987 26.6474 8.5987H17.5592C16.9952 8.5987 16.5163 8.79025 16.1332 9.17336C15.7501 9.55647 15.5585 10.0141 15.5585 10.5355V19.677C15.5585 20.1984 15.7501 20.656 16.1332 21.0391C16.5163 21.4222 16.9952 21.6138 17.5592 21.6138H26.6474C27.1689 21.6138 27.6371 21.4222 28.0415 21.0391C28.4459 20.656 28.6481 20.1984 28.6481 19.677Z"
                    fill="currentColor"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_3619_5376">
                    <rect width="31" height="31" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              Spaces
            </div>
            <div className="submenu-item-bottom">
              Simplify communication, drive participation, and build community.
            </div>
          </a>
          <a
            href="/platform/employee-engagement/"
            className="submenu-prod-item"
          >
            <div className="submenu-item-top">
              <svg
                width="24"
                height="22"
                viewBox="0 0 24 22"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_3575_2608)">
                  <path
                    d="M20.6708 0C21.5438 0 22.3227 0.301255 22.9903 0.895398C23.6579 1.48954 24.0003 2.23431 24.0003 3.12134C24.0003 4.00837 23.6836 4.74477 23.0417 5.34728C22.3997 5.94142 21.6551 6.24268 20.8163 6.24268C20.6879 6.24268 20.5766 6.22594 20.4653 6.20084C20.3541 6.16736 20.2342 6.159 20.1144 6.159L17.1615 11.431C17.4439 11.7071 17.6579 12.0084 17.8205 12.3515C17.9746 12.6862 18.0516 13.0879 18.0516 13.5398C18.0516 14.4268 17.7435 15.1632 17.1358 15.7657C16.5281 16.3682 15.7663 16.6611 14.8591 16.6611C13.9518 16.6611 13.1986 16.3515 12.5823 15.7239C11.9746 15.0962 11.6665 14.3682 11.6665 13.5481C11.6665 13.3389 11.7007 13.1213 11.7606 12.9038C11.8205 12.6862 11.9318 12.4937 12.0859 12.3096L10.725 11.0711C10.5024 11.2552 10.2542 11.3808 9.97175 11.4393C9.6893 11.4979 9.40685 11.5314 9.12439 11.5314C8.99601 11.5314 8.88474 11.5146 8.77347 11.4895C8.6622 11.4561 8.54237 11.4477 8.42254 11.4477L5.46962 16.6695C5.75207 16.9456 5.97461 17.272 6.14579 17.6569C6.31698 18.0418 6.40257 18.4603 6.40257 18.9205C6.40257 19.8075 6.09444 20.5439 5.48673 21.1464C4.87903 21.7406 4.10014 22.0418 3.16719 22.0418C2.23424 22.0418 1.50671 21.7406 0.890444 21.1464C0.282741 20.5523 -0.0253906 19.8075 -0.0253906 18.9205C-0.0253906 18.0335 0.2913 17.2971 0.93324 16.6946C1.57518 16.1004 2.31983 15.7992 3.15863 15.7992C3.28702 15.7992 3.39829 15.8159 3.50956 15.841C3.62083 15.8745 3.7321 15.8828 3.86049 15.8828L6.81341 10.6109C6.47104 10.3347 6.21427 10.0084 6.04308 9.62343C5.8719 9.23849 5.78631 8.83682 5.78631 8.41004C5.78631 7.48954 6.07732 6.71967 6.65078 6.09205C7.23281 5.46444 7.9689 5.15481 8.87618 5.15481C9.78345 5.15481 10.5367 5.46444 11.1529 6.09205C11.7606 6.71967 12.0688 7.4477 12.0688 8.26778C12.0688 8.54393 12.0431 8.80335 12.0003 9.04603C11.9575 9.2887 11.8633 9.52301 11.7435 9.73222L13.1044 10.9707C13.3526 10.8452 13.6351 10.7448 13.9518 10.6527C14.2599 10.5607 14.5595 10.5188 14.8419 10.5188C14.9703 10.5188 15.0816 10.5356 15.1929 10.5607C15.3041 10.5941 15.4154 10.6025 15.5438 10.6025L18.4026 5.38075C18.0859 5.1046 17.8548 4.77824 17.7007 4.39331C17.5466 4.00837 17.4696 3.58996 17.4696 3.12971C17.4696 2.24268 17.7863 1.50628 18.4282 0.903766C19.0702 0.309624 19.8148 0.0083682 20.6536 0.0083682L20.6708 0ZM0.941799 3.25523C0.941799 3.4728 1.01027 3.6569 1.15578 3.80753C1.29273 3.95816 1.48959 4.03347 1.7378 4.03347H2.30271V4.58577C2.30271 4.80335 2.36263 4.99582 2.49101 5.17992C2.6194 5.36402 2.81626 5.45607 3.09872 5.45607C3.38117 5.45607 3.59515 5.36402 3.75778 5.17992C3.91184 4.99582 3.98887 4.79498 3.98887 4.58577V4.03347H4.59658C4.81912 4.03347 5.01598 3.99163 5.20428 3.89958C5.39258 3.80753 5.48673 3.62343 5.48673 3.34728C5.48673 3.07113 5.39258 2.85356 5.20428 2.68619C5.01598 2.51883 4.81056 2.43515 4.59658 2.43515H3.98887V1.88285C3.98887 1.60669 3.94608 1.39749 3.86905 1.23849C3.79201 1.08787 3.61227 1.01255 3.32982 1.01255C3.04736 1.01255 2.82482 1.1046 2.65364 1.2887C2.48245 1.4728 2.39686 1.67364 2.39686 1.88285V2.3431H1.83196C1.5495 2.3431 1.33552 2.43515 1.1729 2.61925C1.01883 2.80335 0.941799 3.01255 0.941799 3.2636V3.25523ZM4.19429 19.682C4.45963 19.3891 4.59658 19.0795 4.59658 18.7448C4.59658 18.41 4.45107 18.1004 4.1515 17.8243C3.85193 17.5481 3.53524 17.4142 3.19287 17.4142C2.8505 17.4142 2.53381 17.5481 2.25136 17.8243C1.9689 18.1004 1.83196 18.4017 1.83196 18.7448C1.83196 19.0879 1.96034 19.3975 2.20856 19.682C2.45678 19.9749 2.79059 20.1172 3.19287 20.1172C3.59515 20.1172 3.93752 19.9749 4.20285 19.682H4.19429ZM7.5495 8.38494C7.5495 8.71967 7.69501 9.02929 7.99458 9.30544C8.29415 9.58159 8.64508 9.71548 9.04736 9.71548C9.42397 9.71548 9.71498 9.58159 9.93752 9.30544C10.1601 9.02929 10.2628 8.72803 10.2628 8.38494C10.2628 8.04184 10.1258 7.73222 9.84337 7.4477C9.56091 7.15481 9.25278 7.01255 8.90185 7.01255C8.55093 7.01255 8.2428 7.14644 7.96034 7.40586C7.67789 7.66527 7.54094 7.99163 7.54094 8.39331L7.5495 8.38494ZM15.8434 14.5941C16.0916 14.3347 16.22 14.0084 16.22 13.6067C16.22 13.205 16.083 12.8703 15.8006 12.6025C15.5181 12.3347 15.21 12.1925 14.8591 12.1925C14.5081 12.1925 14.2 12.3431 13.9175 12.6527C13.6351 12.9623 13.4981 13.2803 13.4981 13.6151C13.4981 13.9498 13.6265 14.2678 13.8747 14.5523C14.123 14.8452 14.4568 14.9874 14.8591 14.9874C15.2613 14.9874 15.5951 14.8536 15.8434 14.5941ZM22.1772 17.8494C22.0231 17.682 21.7835 17.5816 21.4753 17.5481H20.9104V16.954C20.9104 16.6778 20.8334 16.4686 20.6793 16.3096C20.5252 16.159 20.3027 16.0837 20.0203 16.0837C19.7378 16.0837 19.5153 16.1757 19.3441 16.3598C19.1729 16.5439 19.0873 16.7448 19.0873 16.954V17.5481H18.5224C18.2399 17.5481 18.0174 17.6234 17.8462 17.7741C17.675 17.9247 17.5894 18.1423 17.5894 18.4184C17.5894 18.6946 17.6922 18.9121 17.8976 19.0795C18.103 19.2469 18.3084 19.3305 18.531 19.3305H19.0959V19.8828C19.0959 20.159 19.1815 20.3682 19.3526 20.5272C19.5238 20.6778 19.7549 20.7531 20.0288 20.7531C20.3027 20.7531 20.5252 20.6611 20.6879 20.477C20.8419 20.2929 20.919 20.0921 20.919 19.8828V19.3305H21.4839C21.792 19.3305 22.0317 19.2301 22.1857 19.0293C22.3398 18.8285 22.4168 18.6276 22.4168 18.41C22.4168 18.1925 22.3398 18.0084 22.1857 17.841L22.1772 17.8494ZM21.6807 4.03347C21.9461 3.75732 22.083 3.45607 22.083 3.11297C22.083 2.76987 21.9375 2.46862 21.6379 2.19247C21.3384 1.91632 21.0217 1.78243 20.6793 1.78243C20.3369 1.78243 20.0203 1.91632 19.7378 2.19247C19.4553 2.46862 19.3184 2.76987 19.3184 3.11297C19.3184 3.45607 19.4468 3.75732 19.695 4.03347C19.9432 4.30962 20.277 4.44351 20.6793 4.44351C21.0816 4.44351 21.424 4.30962 21.6893 4.03347H21.6807Z"
                    fill="currentColor"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_3575_2608">
                    <rect width="24" height="22" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              Surveys
            </div>
            <div className="submenu-item-bottom">
              Measure program impact, eNPS, and track employee sentiment.{" "}
            </div>
          </a>

          <a href="/service-shoutouts/" className="submenu-prod-item">
            <div className="submenu-item-top">
              <svg
                width="23"
                height="24"
                viewBox="0 0 23 24"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.9761 5.57812C23.008 5.73438 23.008 5.89062 22.9761 6.04688C22.9443 6.20312 22.8647 6.34375 22.7373 6.46875L19.5846 9.46875L20.3011 13.7344C20.333 13.9219 20.3171 14.0938 20.2534 14.25C20.1897 14.4062 20.0942 14.5312 19.9668 14.625C19.8394 14.7188 19.6802 14.7812 19.4891 14.8125C19.3299 14.8125 19.1706 14.7656 19.0114 14.6719L15.0945 12.6562L11.2731 14.6719L12.0374 14.8594C12.0374 14.8594 12.0533 14.875 12.0852 14.9062C12.117 14.9062 12.1329 14.9062 12.1329 14.9062C12.4195 15 12.6584 15.1406 12.8494 15.3281C13.0723 15.4844 13.2316 15.6875 13.3271 15.9375C13.3908 16 13.4226 16.0781 13.4226 16.1719C13.4545 16.2656 13.4863 16.3594 13.5182 16.4531L19.2025 15.9844C19.4891 15.9844 19.7757 16.0312 20.0623 16.125C20.3489 16.2188 20.6196 16.3594 20.8744 16.5469C21.0973 16.7344 21.2724 16.9688 21.3998 17.25C21.5272 17.5 21.6068 17.7812 21.6386 18.0938C21.6705 18.2812 21.6546 18.4844 21.5909 18.7031C21.559 18.8906 21.4953 19.0781 21.3998 19.2656C21.2724 19.5156 21.0973 19.7344 20.8744 19.9219C20.6833 20.1094 20.4444 20.25 20.1578 20.3438L10.8432 23.7656C10.6521 23.8594 10.4451 23.9219 10.2222 23.9531C10.0312 23.9844 9.82416 24 9.60125 24C9.41018 24 9.21911 23.9844 9.02804 23.9531C8.83697 23.9219 8.6459 23.875 8.45483 23.8125L1.81516 21.6562V22.6875C1.81516 22.9375 1.71963 23.1406 1.52856 23.2969C1.36933 23.4844 1.16234 23.5781 0.90758 23.5781C0.684666 23.5781 0.477674 23.4844 0.286604 23.2969C0.0955348 23.1406 0 22.9375 0 22.6875V12.8438C0 12.625 0.0955348 12.4219 0.286604 12.2344C0.477674 12.0469 0.684666 11.9531 0.90758 11.9531C1.16234 11.9531 1.36933 12.0469 1.52856 12.2344C1.71963 12.4219 1.81516 12.625 1.81516 12.8438V13.7812L4.63344 13.3594C4.98373 13.2969 5.33403 13.2812 5.68432 13.3125C6.03461 13.3125 6.38491 13.3594 6.7352 13.4531L9.98339 14.3438C9.95154 14.25 9.9197 14.1562 9.88785 14.0625C9.88785 13.9688 9.88785 13.8594 9.88785 13.7344L10.6521 9.46875L7.49948 6.46875C7.3721 6.34375 7.27657 6.20312 7.21288 6.04688C7.18103 5.89062 7.19695 5.73438 7.26064 5.57812C7.32433 5.39062 7.41987 5.25 7.54725 5.15625C7.67463 5.03125 7.81793 4.96875 7.97716 4.96875L12.324 4.3125L14.2825 0.46875C14.4417 0.15625 14.7124 0 15.0945 0C15.4766 0 15.7473 0.15625 15.9065 0.46875L17.865 4.3125L22.2118 4.96875C22.4029 4.96875 22.5621 5.03125 22.6895 5.15625C22.8169 5.25 22.9124 5.39062 22.9761 5.57812ZM11.7508 16.7344C11.7189 16.7031 11.6871 16.6719 11.6552 16.6406C11.6552 16.6094 11.6234 16.5938 11.5597 16.5938L6.25753 15.1875C6.03461 15.125 5.8117 15.0938 5.58879 15.0938C5.36587 15.0625 5.14296 15.0625 4.92004 15.0938L1.81516 15.6094V19.7812C1.84701 19.7812 1.86293 19.7812 1.86293 19.7812C1.89477 19.7812 1.9107 19.7812 1.9107 19.7812L9.02804 22.125C9.21911 22.1875 9.41018 22.2188 9.60125 22.2188C9.82416 22.2188 10.0312 22.1875 10.2222 22.125L19.5369 18.7031C19.6006 18.6719 19.6483 18.6406 19.6802 18.6094C19.7439 18.5781 19.7757 18.5312 19.7757 18.4688C19.8075 18.4375 19.8235 18.4062 19.8235 18.375C19.8553 18.3125 19.8553 18.2656 19.8235 18.2344C19.8235 18.1719 19.8075 18.1094 19.7757 18.0469C19.7757 17.9844 19.7439 17.9375 19.6802 17.9062C19.6165 17.8438 19.5528 17.8125 19.4891 17.8125C19.4573 17.7812 19.4095 17.7656 19.3458 17.7656L12.9927 18.2344C12.8017 18.4531 12.5628 18.625 12.2762 18.75C12.0215 18.8438 11.7508 18.8906 11.4642 18.8906H6.3053C6.05054 18.8906 5.82762 18.8125 5.63655 18.6562C5.47733 18.4688 5.39772 18.25 5.39772 18C5.39772 17.7812 5.47733 17.5938 5.63655 17.4375C5.82762 17.25 6.05054 17.1562 6.3053 17.1562H11.4642C11.5279 17.1562 11.5756 17.1406 11.6075 17.1094C11.6712 17.0469 11.7189 16.9844 11.7508 16.9219C11.7508 16.8906 11.7508 16.8594 11.7508 16.8281C11.7508 16.7656 11.7508 16.7344 11.7508 16.7344ZM17.9605 8.53125L20.1578 6.46875L17.1485 6C16.9893 6 16.846 5.95312 16.7186 5.85938C16.6231 5.76562 16.5434 5.65625 16.4798 5.53125L15.0945 2.85938L13.757 5.53125C13.6933 5.65625 13.5978 5.76562 13.4704 5.85938C13.343 5.95312 13.2156 6 13.0883 6L10.0789 6.46875L12.2285 8.53125C12.3558 8.625 12.4354 8.75 12.4673 8.90625C12.531 9.03125 12.5469 9.17188 12.5151 9.32812L11.9896 12.2812L14.6646 10.875C14.7601 10.8438 14.8397 10.8281 14.9034 10.8281C14.9671 10.7969 15.0308 10.7812 15.0945 10.7812C15.19 10.7812 15.2696 10.7969 15.3333 10.8281C15.397 10.8281 15.4607 10.8438 15.5244 10.875L18.2471 12.2812L17.7217 9.32812C17.6899 9.17188 17.6899 9.03125 17.7217 8.90625C17.7854 8.75 17.865 8.625 17.9605 8.53125Z"
                  fill="currentColor"
                />
              </svg>
              Service Shoutouts{" "}
            </div>
            <div className="submenu-item-bottom">
              Make it easy for your customers to thank your employees.{" "}
            </div>
          </a>

          <a
            href="/platform/employee-rewards/marketplace#swag"
            className="submenu-prod-item"
          >
            <div className="submenu-item-top">
              <div className="new-badge">New</div>
              <svg
                width="24"
                height="23"
                viewBox="0 0 24 23"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_5762_670)">
                  <path
                    d="M15.8421 0C18.0924 0 20.0146 0.78541 21.6088 2.35623C23.2029 3.92705 24 5.82114 24 8.03623V11.2689C24 11.7015 23.8521 12.0543 23.5541 12.3321C23.2561 12.6098 22.9049 12.7487 22.5006 12.7487H19.5017V20.9693C19.5017 21.5225 19.2984 22.0006 18.8918 22.4013C18.4852 22.8019 18.0023 23.0023 17.4386 23.0023H6.56142C6 23.0023 5.51482 22.8019 5.1082 22.4013C4.70158 22.0006 4.49827 21.5248 4.49827 20.9693V12.7487H1.49942C1.0928 12.7487 0.741625 12.6098 0.445899 12.3321C0.147863 12.0543 0 11.7015 0 11.2689V6.97308C0 5.06533 0.695418 3.42393 2.08625 2.05345C3.47478 0.685242 5.14055 0 7.07663 0H8.15556C8.49981 0 8.81171 0.116104 9.09357 0.346036C9.37543 0.575968 9.56257 0.862813 9.65499 1.19974C9.77975 1.72335 10.0616 2.15362 10.4983 2.49282C10.9349 2.83203 11.4363 3.00049 11.9977 3.00049C12.5591 3.00049 13.0605 2.83203 13.4971 2.49282C13.9338 2.15362 14.2156 1.72335 14.3404 1.19974C14.4351 0.860537 14.6223 0.575968 14.9018 0.346036C15.1837 0.116104 15.4956 0 15.8398 0L15.8421 0ZM22.124 10.9001V8.03623C22.124 6.37434 21.5372 4.94922 20.3658 3.76314C19.1945 2.57706 17.7805 1.95556 16.124 1.89181C15.8421 2.75463 15.3269 3.46946 14.576 4.0386C13.8252 4.60774 12.9657 4.89231 11.9977 4.89231C11.0296 4.89231 10.1702 4.60774 9.41933 4.0386C8.66846 3.46946 8.15325 2.73869 7.87139 1.84401H7.07432C5.63727 1.84401 4.41047 2.34485 3.39392 3.34425C2.37736 4.34594 1.87139 5.55479 1.87139 6.9708V10.8979H4.49596V7.48075C4.49596 7.23488 4.59068 7.01861 4.77782 6.83421C4.96496 6.64981 5.20062 6.55647 5.48017 6.55647C5.72969 6.55647 5.94917 6.64981 6.13631 6.83421C6.32345 7.01861 6.41818 7.23488 6.41818 7.48075V20.967C6.41818 21.0285 6.43435 21.0763 6.46438 21.1059C6.49442 21.1378 6.52676 21.1514 6.55911 21.1514H17.434C17.464 21.1514 17.4963 21.1355 17.5287 21.1059C17.5587 21.0763 17.5749 21.0285 17.5749 20.967V7.48075C17.5749 7.23488 17.6696 7.01861 17.8568 6.83421C18.0439 6.64981 18.2634 6.55647 18.5129 6.55647C18.7948 6.55647 19.0281 6.64981 19.2152 6.83421C19.4024 7.01861 19.4971 7.23488 19.4971 7.48075V10.8979H22.1217L22.124 10.9001ZM15.5626 7.9907C15.5002 7.89736 15.4378 7.8063 15.3754 7.71296C15.3131 7.61962 15.2345 7.54449 15.1421 7.48302C14.7978 7.11422 14.3681 6.92982 13.8529 6.92982C13.3377 6.92982 12.8918 7.11422 12.5175 7.48302L12.0023 7.9907L11.4871 7.48302C11.3924 7.42156 11.3069 7.36009 11.2283 7.29862C11.1498 7.23716 11.0643 7.17569 10.9696 7.11422C10.5006 6.90023 10.0246 6.87519 9.53947 7.04593C9.05429 7.21667 8.68695 7.53083 8.43743 7.99297C8.28032 8.36177 8.23412 8.74879 8.2965 9.14718C8.35888 9.54786 8.52984 9.88706 8.81171 10.1625L11.062 12.5643C11.3115 12.8102 11.6234 12.9331 12 12.9331C12.3766 12.9331 12.6862 12.8102 12.938 12.5643L15.1883 10.1625C15.4702 9.88479 15.6411 9.54786 15.7035 9.14718C15.7659 8.74651 15.7197 8.36177 15.5626 7.99297V7.9907Z"
                    fill="currentColor"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_5762_670">
                    <rect width="24" height="23" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              Rewards by Motivosity
            </div>
            <div className="submenu-item-bottom">
              Get a turnkey or premium SWAG store built for you.{" "}
            </div>
          </a>

          <a
            href="/product/lifestyle-spending-accounts/"
            className="submenu-prod-item"
          >
            <div className="submenu-item-top">
              <div className="new-badge">New</div>
              <svg
                width="27"
                height="23"
                viewBox="0 0 27 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_6287_9097)">
                  <path
                    d="M0.968354 8.98972C0.432911 8.98972 0 8.54606 0 7.99733C0 6.162 1.45595 4.66992 3.24684 4.66992C3.78228 4.66992 4.21519 5.11358 4.21519 5.66231C4.21519 6.21104 3.78228 6.65469 3.24684 6.65469C2.52456 6.65469 1.93671 7.25713 1.93671 7.99733C1.93671 8.54606 1.5038 8.98972 0.968354 8.98972Z"
                    fill="currentColor"
                  />
                  <path
                    d="M21.4734 8.98972C20.938 8.98972 20.505 8.54606 20.505 7.99733C20.505 7.25713 19.9172 6.65469 19.1949 6.65469C18.6595 6.65469 18.2266 6.21104 18.2266 5.66231C18.2266 5.11358 18.6595 4.66992 19.1949 4.66992C20.9858 4.66992 22.4418 6.162 22.4418 7.99733C22.4418 8.54606 22.0088 8.98972 21.4734 8.98972Z"
                    fill="currentColor"
                  />
                  <path
                    d="M19.1949 22.9995C18.6595 22.9995 18.2266 22.5558 18.2266 22.0071C18.2266 21.4584 18.6595 21.0147 19.1949 21.0147C19.9172 21.0147 20.505 20.4123 20.505 19.6721C20.505 19.1233 20.938 18.6797 21.4734 18.6797C22.0088 18.6797 22.4418 19.1233 22.4418 19.6721C22.4418 21.5074 20.9858 22.9995 19.1949 22.9995Z"
                    fill="currentColor"
                  />
                  <path
                    d="M3.24684 22.9995C1.45595 22.9995 0 21.5074 0 19.6721C0 19.1233 0.432911 18.6797 0.968354 18.6797C1.5038 18.6797 1.93671 19.1233 1.93671 19.6721C1.93671 20.4123 2.52456 21.0147 3.24684 21.0147C3.78228 21.0147 4.21519 21.4584 4.21519 22.0071C4.21519 22.5558 3.78228 22.9995 3.24684 22.9995Z"
                    fill="currentColor"
                  />
                  <path
                    d="M0.968354 20.6658C0.432911 20.6658 0 20.2221 0 19.6734V7.99825C0 7.44951 0.432911 7.00586 0.968354 7.00586C1.5038 7.00586 1.93671 7.44951 1.93671 7.99825V19.6734C1.93671 20.2221 1.5038 20.6658 0.968354 20.6658Z"
                    fill="currentColor"
                  />
                  <path
                    d="M21.4762 20.6638C20.9407 20.6638 20.5078 20.2201 20.5078 19.6714V7.99629C20.5078 7.44756 20.9407 7.00391 21.4762 7.00391C22.0116 7.00391 22.4445 7.44756 22.4445 7.99629V19.6714C22.4445 20.2201 22.0116 20.6638 21.4762 20.6638Z"
                    fill="currentColor"
                  />
                  <path
                    d="M19.199 23.0004H3.2496C2.71416 23.0004 2.28125 22.5567 2.28125 22.008C2.28125 21.4593 2.71416 21.0156 3.2496 21.0156H19.199C19.7344 21.0156 20.1673 21.4593 20.1673 22.008C20.1673 22.5567 19.7344 23.0004 19.199 23.0004Z"
                    fill="currentColor"
                  />
                  <path
                    d="M19.199 6.65469H3.2496C2.71416 6.65469 2.28125 6.21104 2.28125 5.66231C2.28125 5.11358 2.71416 4.66992 3.2496 4.66992H19.199C19.7344 4.66992 20.1673 5.11358 20.1673 5.66231C20.1673 6.21104 19.7344 6.65469 19.199 6.65469Z"
                    fill="currentColor"
                  />
                  <path
                    d="M5.52304 4.3198C4.9876 4.3198 4.55469 3.87614 4.55469 3.32741C4.55469 1.49208 6.01064 0 7.80152 0C8.33697 0 8.76988 0.443655 8.76988 0.992386C8.76988 1.54112 8.33697 1.98477 7.80152 1.98477C7.07924 1.98477 6.4914 2.58721 6.4914 3.32741C6.4914 3.87614 6.05848 4.3198 5.52304 4.3198Z"
                    fill="currentColor"
                  />
                  <path
                    d="M26.032 4.3198C25.4965 4.3198 25.0636 3.87614 25.0636 3.32741C25.0636 2.58721 24.4758 1.98477 23.7535 1.98477C23.2181 1.98477 22.7852 1.54112 22.7852 0.992386C22.7852 0.443655 23.2181 0 23.7535 0C25.5444 0 27.0003 1.49208 27.0003 3.32741C27.0003 3.87614 26.5674 4.3198 26.032 4.3198Z"
                    fill="currentColor"
                  />
                  <path
                    d="M23.7535 18.3296C23.2181 18.3296 22.7852 17.8859 22.7852 17.3372C22.7852 16.7884 23.2181 16.3448 23.7535 16.3448C24.4758 16.3448 25.0636 15.7424 25.0636 15.0022C25.0636 14.4534 25.4965 14.0098 26.032 14.0098C26.5674 14.0098 27.0003 14.4534 27.0003 15.0022C27.0003 16.8375 25.5444 18.3296 23.7535 18.3296Z"
                    fill="currentColor"
                  />
                  <path
                    d="M5.52304 6.65573C4.9876 6.65573 4.55469 6.21208 4.55469 5.66335V3.32832C4.55469 2.77959 4.9876 2.33594 5.52304 2.33594C6.05849 2.33594 6.4914 2.77959 6.4914 3.32832V5.66335C6.4914 6.21208 6.05849 6.65573 5.52304 6.65573Z"
                    fill="currentColor"
                  />
                  <path
                    d="M26.0309 15.9958C25.4954 15.9958 25.0625 15.5522 25.0625 15.0034V3.32832C25.0625 2.77959 25.4954 2.33594 26.0309 2.33594C26.5663 2.33594 26.9992 2.77959 26.9992 3.32832V15.0034C26.9992 15.5522 26.5663 15.9958 26.0309 15.9958Z"
                    fill="currentColor"
                  />
                  <path
                    d="M23.7546 18.3285H21.4762C20.9407 18.3285 20.5078 17.8849 20.5078 17.3361C20.5078 16.7874 20.9407 16.3438 21.4762 16.3438H23.7546C24.2901 16.3438 24.723 16.7874 24.723 17.3361C24.723 17.8849 24.2901 18.3285 23.7546 18.3285Z"
                    fill="currentColor"
                  />
                  <path
                    d="M23.7537 1.98477H7.80429C7.26885 1.98477 6.83594 1.54112 6.83594 0.992386C6.83594 0.443655 7.26885 0 7.80429 0H23.7537C24.2891 0 24.722 0.443655 24.722 0.992386C24.722 1.54112 24.2891 1.98477 23.7537 1.98477Z"
                    fill="currentColor"
                  />
                  <path
                    d="M21.4747 12.4926H0.968354C0.432911 12.4926 0 12.0489 0 11.5002C0 10.9515 0.432911 10.5078 0.968354 10.5078H21.4747C22.0101 10.5078 22.443 10.9515 22.443 11.5002C22.443 12.0489 22.0101 12.4926 21.4747 12.4926Z"
                    fill="currentColor"
                  />
                  <path
                    d="M10.08 18.3285H5.52304C4.9876 18.3285 4.55469 17.8849 4.55469 17.3361C4.55469 16.7874 4.9876 16.3438 5.52304 16.3438H10.08C10.6154 16.3438 11.0484 16.7874 11.0484 17.3361C11.0484 17.8849 10.6154 18.3285 10.08 18.3285Z"
                    fill="currentColor"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_6287_9097">
                    <rect width="27" height="23" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              Lifestyle Spending Accounts
            </div>
            <div className="submenu-item-bottom">
              Easily configure, launch, and administer spending account
              programs.{" "}
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

const ResourcesDropDown = ({ data }) => {
  return (
    <div className="submenu-resources">
      <div className="submenu-resources__container">
        <div className="submenu-resources__type-container">
          <p className="submenu-resources__title">
            <StaticImage
              src="../../../resources/images/navigation/resource.png"
              alt="Grid for resources"
              style={{ marginRight: "13px", width: "20px" }}
            />
            Resource Library
          </p>

          <div className="submenu-resources__type-container">
            {data.links.map((link) => {
              return (
                <a
                  className={"submenu-resources__type "}
                  href={link.href}
                  key={link.href}
                >
                  {link.label}
                </a>
              );
            })}
          </div>
        </div>

        <div className="submenu-resources__featured-resource-container">
          <div className="submenu-resources__image-container">
            <StaticImage
              src="../../../resources/images/navigation/Blog-Mockup.png"
              alt="Image of our blog"
              className="submenu-resources__image"
              placeholder="blurred"
            />
          </div>
          <p className="submenu-resources__featured-resource-text">
            Rewards and Recognition Program: Benefits, Challenges, and Guidance
          </p>
          <a href="/resources/" className="submenu-resources__link">
            Read Blog{" "}
            <FontAwesomeIcon icon={faAngleRight} alt="Icon pointing right" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default TransparentHeaderTemplate;
